import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/global.scss';

declare global {
  interface Window {
    wakoCustomFlowData?: {
      mappings: any[]; // ここは後で厳密な型を定義する
    };
  }
}

const container = document.getElementById('wako-custom-order-flow-root');

if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.warn('React mount point #wako-custom-order-flow-root not found in the DOM.');
}